import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createFeedback } from "../../redux/ApiSlice/ContactUs";

export default function ContactUs() {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.contactUs);

    const [form, setForm] = useState({ full_name: "", email: "", feedback: "" });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await dispatch(createFeedback(form));
        if (result.meta.requestStatus === "fulfilled") {
            setSubmitted(true);
            setForm({ full_name: "", email: "", feedback: "" });
        }
    };

    return (
        <div className="h-full w-full overflow-y-auto">
            <div className="mx-auto w-full max-w-[940px] px-10 py-12 lg:py-16">
                <div className="mx-auto max-w-[520px]">
                    <h1 className="text-[30px] font-black text-black">Contact Us</h1>
                    <p className="mt-2 text-[15px] text-[#7A7A7A]">
                        Everything you need to connect with your neighborhood and the people who share your interests.
                    </p>

                    {submitted && (
                        <p className="mt-4 text-[14px] font-semibold text-green-600">
                            Thank you! Your message has been sent.
                        </p>
                    )}

                    <form className="mt-8 space-y-4" onSubmit={handleSubmit}>
                        <label className="block rounded-[10px] border border-[#96D2F4] bg-[#F7FAFC] px-4 py-3">
                            <span className="block text-[12px] font-semibold text-black">Full Name</span>
                            <input
                                type="text"
                                name="full_name"
                                placeholder="Your name"
                                value={form.full_name}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full bg-transparent text-[14px] text-[#222222] outline-none placeholder:text-[#9A9A9A]"
                            />
                        </label>

                        <label className="block rounded-[10px] border border-[#96D2F4] bg-[#F7FAFC] px-4 py-3">
                            <span className="block text-[12px] font-semibold text-black">Email Address</span>
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter your email here"
                                value={form.email}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full bg-transparent text-[14px] text-[#222222] outline-none placeholder:text-[#9A9A9A]"
                            />
                        </label>

                        <label className="block rounded-[10px] border border-[#96D2F4] bg-[#F7FAFC] px-4 py-3">
                            <span className="block text-[12px] font-semibold text-black">Message</span>
                            <textarea
                                rows={7}
                                name="feedback"
                                placeholder="We'd love to hear from you!"
                                maxLength={500}
                                value={form.feedback}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full resize-none bg-transparent text-[14px] text-[#222222] outline-none placeholder:text-[#9A9A9A]"
                            />
                            <span className={`block text-right text-[11px] mt-1 ${form.feedback.length >= 500 ? "text-red-500" : "text-[#9A9A9A]"}`}>
                                {form.feedback.length}/500
                            </span>
                        </label>

                        <button
                            type="submit"
                            disabled={loading}
                            className="h-9 rounded-full bg-[#BEE6FF] px-8 text-[14px] font-semibold text-[#1B2E3B] hover:bg-[#A7DBFB] disabled:opacity-60"
                        >
                            {loading ? "Sending..." : "Submit"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
